import { fonts } from '@opallabs/pulsar'
import { sharedColors } from '../sharedStyles'

const gradientLayer = {
  bottom: {
    background: `linear-gradient(0deg, ${sharedColors.black(
      0.25
    )} 0%, ${sharedColors.black(0)} 100%)`,
    height: '300px',
    width: '375px',
    position: 'absolute',
    bottom: '0',
    zIndex: '0',
  },
  top: {
    background: `linear-gradient(180deg, ${sharedColors.black(
      0.25
    )} 0%, ${sharedColors.black(0)} 100%)`,
    height: '150px',
    width: '375px',
    position: 'absolute',
    top: '0',
    zIndex: '0',
  },
}

const avatar = {
  border: `solid 1px ${sharedColors.white()}`,
  marginBottom: '26px',
  img: {
    height: '100%',
    objectFit: 'cover',
  },
}

const input = (readOnly) => {
  const base = {
    backgroundColor: 'transparent',
    color: sharedColors.white(),
    padding: 0,
    width: '100%',
  }

  const editable = {
    '&:hover': {
      backgroundColor: sharedColors.inputHover,
    },
  }

  return {
    ...base,
    ...(!readOnly ? editable : {}),
  }
}

const inputPlaceholder = {
  color: sharedColors.white(0.9),
}

const captionInput = (readOnly) => ({
  ...input(readOnly),
  width: 260,
})

const soundInput = (readOnly) => ({
  ...input(readOnly),
  width: 234,
})

const postContent = {
  width: '260px',
  position: 'absolute',
  bottom: '50px',
  padding: '12px',
  zIndex: '1',
  '& > div:first-of-type, & > div:last-of-type': {
    alignItems: 'flex-start',
    display: 'flex',
    width: '100%',
  },
  avatarUsername: {
    fontWeight: 'bold',
    marginBottom: '6px',
    paddingLeft: '5px',
    span: {
      fontSize: '16px',
    },
    p: {
      margin: '0 0 0 6px',
      fontSize: '14px',
      color: sharedColors.white(0.5),
      flexShrink: 0,
      whiteSpace: 'nowrap',
      span: {
        fontSize: '6px',
        transform: 'translateY(-3px)',
        display: 'inline-block',
      },
    },
  },
  soundIcon: {
    style: {
      color: sharedColors.white(),
      padding: '7px 5px 0 5px',
      height: 12,
      width: 12,
    },
  },
  soundInput: {
    width: '100%',
  },
}

const chevronIcon = {
  style: {
    position: 'absolute',
    top: '18px',
    left: '15px',
    color: sharedColors.white(),
    zIndex: 1,
  },
}

const commentBar = {
  height: '50px',
  width: '375px',
  boxSizing: 'border-box',
  borderTop: `1px solid ${sharedColors.white()}`,
  display: 'flex',
  justifyContent: 'space-between',
  position: 'absolute',
  bottom: '0',
  zIndex: '1',
  p: {
    color: sharedColors.white(0.3),
    padding: '15px 17px',
    margin: '0',
    fontSize: '14px',
    height: '20px',
    letterSpacing: '0px',
    lineHeight: '20px',
    width: '170px',
  },
  ul: {
    display: 'flex',
    listStyleType: 'none',
    width: '66px',
    margin: '0',
    padding: '13.5px 17px',
    justifyContent: 'space-between',
  },
  icon: {
    style: {
      height: 22,
      width: 22,
      color: sharedColors.white(0.5),
    },
  },
}

const iconsBar = {
  position: 'absolute',
  width: '50px',
  right: 0,
  padding: '0 6px 12px 0',
  bottom: '50px',
  zIndex: '1',
  ul: {
    listStyleType: 'none',
    margin: 0,
    padding: 0,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  heartIcon: {
    style: {
      color: sharedColors.white(),
      height: '25px',
      width: '30px',
      paddingBottom: '26px',
    },
  },
  commentIcon: {
    style: {
      color: sharedColors.white(),
      height: '26px',
      width: '30px',
      paddingBottom: '26px',
    },
  },
  favoriteIcon: {
    style: {
      color: sharedColors.white(),
      height: '23px',
      width: '30px',
      paddingBottom: '26px',
    },
  },
  shareIcon: {
    style: {
      color: sharedColors.white(),
      height: '20px',
      width: '32px',
      paddingBottom: '26px',
    },
  },
  recordIcon: {
    style: {
      height: 34,
      width: 34,
    },
  },
}

const collabSeparator = {
  color: sharedColors.white(),
  flexShrink: 0,
  fontFamily: fonts.sansSerif,
  whiteSpace: 'pre',
}

const withCollab = 'with-collab'
const withCollabSelector = `.kuiper-${withCollab}`

const nameRow = {
  alignItems: 'baseline',
  display: 'flex',
  [`&${withCollabSelector}`]: {
    flex: '1 1 auto',
    minWidth: 0,
    overflow: 'hidden',
  },
  [`&${withCollabSelector} .kuiper-account-name`]: {
    display: 'block',
    flex: '0 1 auto',
    minWidth: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
}

export const styles = {
  avatar,
  captionInput,
  chevronIcon,
  collabSeparator,
  commentBar,
  gradientLayer,
  iconsBar,
  inputPlaceholder,
  nameRow,
  postContent,
  soundInput,
  withCollab,
}
